import { formatCurrency } from '../../utils/formatCurrency';

export const usePOSSelectedProduct = (
    product: any
) => {
    // =====================================================
    // 🔹 Values
    // =====================================================

    const quantity =
        Number(product.quantity || 0);

    const unitPrice =
        Number(product.unitPrice || 0);

    // =====================================================
    // 🔹 Total
    // =====================================================

    const total =
        Number(
            product.taxedAmount ??
            product.netAmount ??
            0
        );

    // =====================================================
    // 🔹 Unit
    // =====================================================

    const normalizedUnit =
        product.unit === 'unid'
            ? quantity === 1
                ? 'unidad'
                : 'unidades'
            : product.unit;

    // =====================================================
    // 🔹 Display
    // =====================================================

    const formattedPrice =
        `$${formatCurrency(unitPrice)}`;

    const formattedTotal =
        `$${formatCurrency(total)}`;

    const quantityLabel =
        `${quantity} ${normalizedUnit} × ${formattedPrice}`;

    // =====================================================
    // 🔹 Flags
    // =====================================================

    const hasDiscount =
        Number(product.discount || 0) > 0;

    // =====================================================
    // 🔹 Exports
    // =====================================================

    return {
        quantity,
        unitPrice,
        total,

        formattedPrice,
        formattedTotal,
        quantityLabel,

        normalizedUnit,

        hasDiscount,
    };
};